<template>
  <div id="system">
    <page-banner title="系统方案" content="拥有多种智慧校园教育装备系统方案"></page-banner>
    <div class="breadcrumb-nav">
      <v-breadcrumb separator="/" separatorClass="fa fa-angle-right">
        <v-breadcrumb-item v-for="item in nav" :key="item.path" :to="item.path">{{item.name}}</v-breadcrumb-item>
      </v-breadcrumb>
    </div>

    <div class="system-content" v-if="show">
      <div
        class="ce"
        v-for="item in plans.plans"
        :key="item.id"
        v-on:mouseenter="amplifier($event)"
        v-on:mouseleave="normal($event)"
        v-on:click="showContent(item.id)"
      >
        <div class="ce-title">
          <h2 style="margin-bottom:10px;color:#fff;font-weight:700;font-size:28px;">{{item.title}}</h2>
          <div>
            <span style="color:#666;">{{item.date}}</span>
          </div>
        </div>
      </div>

      <v-pagination
        :total="total"
        v-on:prev="prev"
        v-on:next="next"
        v-on:changePage="changePage"
        v-if="total>0"
      ></v-pagination>
    </div>
    <router-view v-bind:content="plan_html"></router-view>
  </div>
</template>
<style scoped>
#system {
  width: 100%;
  min-height: 800px;
  /* height:400; */
}
.ce {
  width: 844px;
  height: 248px;
  background-color: #0060ef;
  margin: 50px auto;
  cursor: pointer;
  border-radius: 4px;
  overflow: hidden;
  transform: scale(1);
  transition: 0.2s;
}
.ce-title {
  padding: 66px 32px 32px 32px;
  text-align: center;
  box-sizing: border-box;
}
.system-content {
  /* width: 1200px; */
  width: 1000px;
  height: 100%;
  margin: 0 auto;
  margin-bottom: 20px;
  overflow: hidden;
}
</style>
<script>
export default {
  name: "system",
  data() {
    return {
      nav: [
        { path: "/", name: "首页" },
        { path: "/system_scheme", name: "系统方案" }
      ],
      plans: [],
      show: true,
      plan_html: "",
      pagegroup: 6,
      total: 0
    };
  },
  methods: {
    showPlan(index) {
      this.$refs.content.innerHTML = this.plans[index].content;
    },
    amplifier(event) {
      $(event.target).css("transform", "scale(1.1)");
      console.log($(event.target));
    },
    normal(event) {
      $(event.target).css("transform", "scale(1)");
    },
    showContent(plan_id) {
      this.show = false;
      this.$router.push(`/system_scheme/${plan_id}`);
    },
    prev(currentPage) {
      console.log(currentPage);
      var _this = this;
      $.ajax({
        url: `/plans.php?page=${currentPage}`,
        type: "get",
        data: "",
        success: function(data, textStatus, jqXHR) {
          _this.plans = JSON.parse(data);
        }
      });
    },
    next(currentPage) {
      var _this = this;
      $.ajax({
        url: `/plans.php?page=${currentPage}`,
        type: "get",
        data: "",
        success: function(data, textStatus, jqXHR) {
          _this.plans = JSON.parse(data);
        }
      });
      console.log(currentPage);
    },
    changePage(page) {
      var _this = this;
      $.ajax({
        url: `/plans.php?page=${page}`,
        type: "get",
        data: "",
        success: function(data, textStatus, jqXHR) {
          _this.plans = JSON.parse(data);
        }
      });
      console.log(page);
    }
  },
  mounted() {
    var _this = this;
    $.ajax({
      url: "/plans.php?page=1",
      type: "get",
      data: "",
      success: function(data, textStatus, jqXHR) {
        _this.plans = JSON.parse(data);
        console.log(_this.plans.total);
        _this.total = _this.plans.total;
      }
    });
  }
};
</script>







// WEBPACK FOOTER //
// src/components/system-scheme-content.vue